import {withClassNames} from 'quickstart/theme'
import S from './styles.module.css'

export const BrowseGalleryGrid = withClassNames(S['browse-gallery-grid'])('div')
